module.exports = __webpack_public_path__ + "img/ethereum-logo.3c4a87bc.png";